module.exports = __webpack_public_path__ + "fonts/iconfont.5dab2c3.woff";